module.exports = __webpack_public_path__ + "media/staySafe2.30d36a44.mp3";